export function debounce(func, wait, immediate) {
  let timeout;
  const returValue = function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    }, wait);
    if (immediate && !timeout) func.apply(this, [...args]);
  };

  returValue.cancel = () => clearTimeout(timeout);

  return returValue;
}

export function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

export function replaceImageForSVG(node, afterReplacingCallback) {
  const $img = $(node);
  const imgId = $img.attr("id");
  const imgSrc = $img.attr("src");
  const imgClass = $img.attr("class");

  // Do nothing if we don't work with an SVG image or image at all
  if (!imgSrc || imgSrc.indexOf(".svg") === -1) {
    return;
  }

  $.get(
    imgSrc,
    (d) => {
      // Get the SVG tag, ignore the rest
      const $svg = $(d).find("svg");

      // Remove svg's id attribute
      $svg.removeAttr("id");

      // Replace image id attribute
      if (imgId) $svg.attr("id", imgId);

      // Add replaced classnames
      if (imgClass) $svg.attr("class", `${imgClass} replaced-svg`);

      // Remove any invalid XML tags as per http://validator.w3.org
      $svg.removeAttr("xmlns:a");

      // Check if the viewport is set
      // If the viewport is not set the SVG wont't scale.
      const viewBox = $svg.attr("viewBox");
      const width = $svg.attr("width");
      const height = $svg.attr("height");

      if (!viewBox && width && height) {
        $svg.attr("viewBox", `0 0 ${height} ${width}`);
      }

      if (width) {
        $svg.attr("width", width);
      }

      if (height) {
        $svg.attr("height", height);
      }

      $img.replaceWith($svg);

      // // Remove inline styles
      // inlineCSS($svg.prop('outerHTML'), { url: ' ' })
      //     .then((html) => {
      //         // Replace image with new SVG
      //         $img.replaceWith($(html));
      //     });

      if (afterReplacingCallback) {
        afterReplacingCallback();
      }
    },
    "xml"
  );
}

export function fixInfiniteSliderBlinking($slider) {
  $slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
    if (nextSlide === 0) {
      let cls = "slick-current slick-active slick-center";

      setTimeout(() => {
        $slider
          .find('[data-slick-index="' + slick.$slides.length + '"]')
          .addClass(cls)
          .siblings()
          .removeClass(cls);
        $slider.find('[data-slick-index="0"]').addClass(cls);
      }, 10);
    }
  });
}

export function getParameterByName(name, url) {
  let urlObject = new URL(url ? url : window.location.href);
  let params = new URLSearchParams(urlObject.search);
  return params.get(name);
  
  // if (!url) url = window.location.href;
  // name = name.replace(/[\[\]]/g, "\\$&");
  // var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //   results = regex.exec(url);
  // if (!results) return null;
  // if (!results[2]) return "";
  // return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const isLocalStorageAvailable = () => {
  let test = "test";
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

export function equalHeight(selector, reset = false) {
  const elements = $(selector);
  let maxHeight = 0;

  if (elements.length > 1) {
    elements.each((index, element) => {
      $(element).css("height", "auto");

      if (!reset) {
        maxHeight =
          $(element).outerHeight() > maxHeight
            ? $(element).outerHeight()
            : maxHeight;
      }
    });

    if (!reset) {
      elements.each((index, element) => {
        $(element).css("height", maxHeight);
      });
    }
  }
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes("safari") && !userAgent.includes("chrome");
}

export function isFirefox() {
  return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
}
